"use client";
import { MouseEventHandler, useCallback, useMemo } from "react";

import styled from "styled-components";
import { BaseStyledLink, LinkWithStyle } from "../styles/globalsStyles";
import { defaultTheme } from "../styles/defaultTheme";
import { RouteInfo } from "../utils/clientRoutes";
import { usePathname } from "next/navigation";

interface NavbarLinkProps {
  route: RouteInfo;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  fontSize?: string | number;
}

export const StyledLink = ({ route, onClick, fontSize }: NavbarLinkProps) => {
  const pathname = usePathname(); // <-- gets current URL path

  const isActive = useMemo(
    () =>
      pathname == route.href ||
      route.subRoutes?.find((subRoute) => subRoute.href === pathname),
    [pathname, route.href, route.subRoutes]
  );

  const handleClick: MouseEventHandler<HTMLAnchorElement> = useCallback(
    (e) => {
      if (route.subRoutes) {
        e.preventDefault();
      }
      if (onClick) {
        onClick(e);
      }
    },
    [onClick, route.subRoutes]
  );

  if (isActive) {
    return (
      <ActiveStyledLink
        style={{ fontSize }}
        onClick={handleClick}
        href={`${route.subRoutes ? "" : route.href}`}
      >
        {route.text}
      </ActiveStyledLink>
    );
  }
  return (
    <LinkWithStyle
      style={{ fontSize }}
      onClick={handleClick}
      href={`${route.subRoutes ? undefined : route.href}`}
    >
      {route.text}
    </LinkWithStyle>
  );
};

const ActiveStyledLink = styled(BaseStyledLink)`
  color: ${defaultTheme.secondaryColor};
  cursor: default;
`;
